import { useState, useEffect } from 'react';
import axios from 'axios';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

const useRole = (roleId) => {
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(true);
    const authHeader = useAuthHeader();

    useEffect(() => {
        const fetchRole = async () => {
            const options = {
                headers: {
                    Authorization: authHeader,
                    Accept: 'application/json'
                }
            };

            const baseURL = process.env.REACT_APP_ENV === 'development'
                ? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
                : `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

            try {
                const response = await axios.get(`${baseURL}/roles/${roleId}`, options);
                setRole(response.data.data.role_name); // Assuming the API returns the role in the response
            } catch (error) {
                console.error('Failed to fetch role', error);
            } finally {
                setLoading(false);
            }
        };

        if (roleId) {
            fetchRole();
        }
    }, [roleId, authHeader]);

    return { role, loading };
};

export default useRole;